import { render, staticRenderFns } from "./MemoryList.vue?vue&type=template&id=3701b6d4&scoped=true&"
import script from "./MemoryList.vue?vue&type=script&lang=js&"
export * from "./MemoryList.vue?vue&type=script&lang=js&"
import style0 from "./MemoryList.vue?vue&type=style&index=0&id=3701b6d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3701b6d4",
  null
  
)

export default component.exports